import styled from "styled-components";
import { Modal, Paper } from "@mui/material";

export const ModalCustom = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const ModalContainer = styled(Paper)`
  width: 420px;
  background: #fff;
  border-radius: 3px;
`;

export const ModalWrapper = styled.div`
  padding: 10px;
`;

export const ModalActions = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  padding: 20px;
`;

export const TableRelatorio = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: auto;

  th {
    font-weight: 600;
    :first-child {
      border-radius: 6px 0px 0px 6px;
      ::first-letter {
        margin-left: 8px;
      }
    }

    :last-child {
      border-radius: 0px 6px 6px 0px;
      padding-right: 8px;
    }
  }

  td {
    :first-child {
      padding-left: 8px;
    }

    :last-child {
      padding-right: 8px;
    }
  }

  tbody table td {
    :last-child {
      padding: 0;
    }
  }

  b {
    font-size: 12px;
  }

  th,
  td {
    padding: 0;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
  }

  .table-primary {
    td {
      :first-child {
        border-radius: 6px 0px 0px 6px;
      }

      :last-child {
        border-radius: 0px 6px 6px 0px;
      }
    }
  }
`;

export const VisualizacaoRelatorioContainer = styled.div`
  font-size: 11px;
  width: 250mm;
  height: 300mm;
  margin: 0 auto;
  margin-top: 20mm;
  box-shadow: 0 0 2em gray;
  padding: 2em;
`;

export const ImpressaoRelatorioContainer = styled.div`
  font-size: 10px;
  margin: 0 auto;
  padding: 2em;
  page-break-after: always;
`;
